import { PHONE_MASKS } from "@/constants";

const getPhoneSettings = (country) => {
  return PHONE_MASKS[country];
}

export default getPhoneSettings
